import BonusManagementTable from './BonusManagementTable';

export default BonusManagementTable;
